/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Param } from '../components/add-family-information/add-family-information-types';
import { ProjectDataReturnCodes } from '../models/project-data-return-codes';
import { LocalStorageService } from '@hcworkspace/sysque/toolbelt/utils';
import { GlobalConstants } from '../constants/global-constants';

export class AddProjectDataReceiveController {
  constructor(private localStorageService: LocalStorageService) {}

  public AddProjectParameterDataResult(response: ProjectDataReturnCodes, paramList: Param[]): void {
    this.localStorageService.updateDispatchLocalStorage(GlobalConstants.ADD_PROJECT_PARAMETER_RESPONSE, {
      response,
      paramList,
    });
  }
}